__turbopack_context__.v({
  "link": "meta-navigation-link-module-scss-module__3J1WwG__link",
  "link-active": "meta-navigation-link-module-scss-module__3J1WwG__link-active",
  "placeholder": "meta-navigation-link-module-scss-module__3J1WwG__placeholder",
});
